/**
 * @readonly
 * @enum {Number}
 */
const blindLevelsEnum = [
    10,
    20,
    30,
    40,
    50,
    60
]

const defaultBlindLevel = 20;

export {
    blindLevelsEnum,
    defaultBlindLevel
}
